import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IRegistrationEvent } from "../models/registrationevent.model";

@Injectable()
export class RegistrationEventService {
    public getInitialTaskData(): Observable<IRegistrationEvent[]> {
        const myDate = new Date();
        const toMyDate = new Date();
        return of([]);
    }
}